import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { Location } from '../models/location.model';

@Injectable()
export class SpatialAssetService {
  api_url: string;

  constructor(private apiService: ApiService) {
    this.api_url = environment.cdt.api_url;
  }

  listLocations(siteId: string): Observable<[Location]> {
    return this.apiService.get('sites/' + siteId + '/spatialassets/locations', this.api_url);
  }

  assignLocations(siteId: string, locationInfo: Location, assetsIri: Array<string>) {
    return this.apiService.post('sites/' + siteId + '/spatialassets/assignlocation', this.api_url, JSON.stringify({
      assetsIri: assetsIri,
      locationInfo: locationInfo
    }));
  }
}
